import React from "react";

import { Plus, User } from "lucide-react";
import { Button as EDSButton } from "../../../../ui/button";

export type BookingShortcutsProps = {
  onBookingShortcut: (numPeople?: number) => void;
};

export const BookingShortcuts = ({
  onBookingShortcut
}: BookingShortcutsProps) => {
  const shortcuts = [1, 2, 3, 4, 5];

  return (
    <div className="BookingShortcuts transition-all duration-300 ease-in-out overflow-hidden">
      <div className="BookingShortcuts__row flex gap-2 justify-between items-center">
        <EDSButton
          variant="default"
          size="icon"
          className="BookingShortcuts__button BookingShortcuts__button--add eds-button"
          onClick={() => onBookingShortcut()}
        >
          <Plus />
        </EDSButton>
        {shortcuts.map((num) => (
          <EDSButton
            key={num}
            variant="outline"
            size="sm"
            className="BookingShortcuts__button BookingShortcuts__button--numbered eds-button booking-shortcut-numbered"
            onClick={() => onBookingShortcut(num)}
            style={
              {
                "--icon-size": "16px"
              } as React.CSSProperties
            }
          >
            <User style={{ width: "16px", height: "16px" }} />
            {num}
          </EDSButton>
        ))}
      </div>
    </div>
  );
};
